import {IDelete} from "../interfaces/requests";
import {api} from "utils/service";

export const axiosDelete = ({url}: IDelete) => {
  return api.delete(url);
};
